export default {
  admin: {
    name: '管理员',
    // 属性（一般与对象内容匹配）
    prop: {
      username: '用户名',
      name: '姓名',
      email: '邮箱',
      admin_type: '管理员类型',
      mobile: '手机',
      roles: '角色',
      role: '角色',
      service_provider: '归属运营商',
      ev_charging_station_ids: '可访问站',
      group_ids: '可访问集团',
      sign_in_count: '登录次数',
      login_failed_count: '登录失败次数',
      last_sign_in_at: '最近登录时间',
      last_sign_in_ip: '最近登录IP',
      last_access_at: '最近访问时间',
      created_at: '创建时间',
      updated_at: '更新时间',
      password: '密码',
      ev_charging_stations: '允许访问的站',
      groups: '允许访问的集团',
      status: '状态',
      auth_scope: '开放的权限',
      client: '客户端',
      avatar: '头像',
      sale_entrypoint: '销售代理入口',
      relationship: '是否关联'
    },
    columns: {
      userinfo: '用户信息',
      username: '用户名',
      name: '姓名',
      email: '邮箱',
      admin_type: '管理员类型',
      authorizations: '权限',
      mobile: '手机',
      roles: '角色',
      service_provider_id: '运营商',
      service_provider: '运营商',
      sign_in_count: '登录次数',
      current_sign_in_at: '本次登录时间',
      current_sign_in_ip: '本次登录IP',
      last_sign_in_at: '最近登录时间',
      last_sign_in_ip: '最近登录IP',
      last_access_at: '最近访问时间',
      created_at: '创建时间',
      updated_at: '更新时间',
      status: '状态',
      client: '客户端'
    },
    // 客户端
    clients: {
      pc: '平台端',
      sp: '运营端'
    },
    // 状态
    statuses: {
      enabled: '可用',
      disabled: '已禁用'
    },
    auth_scopes: {
      auth_unlimited: '默认权限',
      auth_limited: '指定权限'
    },
    list_tabs: {
      all: '全部',
      enabled: '可用的',
      disabled: '已禁用'
    },
    // 关联
    // 标签
    detail_tags: {
      detail: '基础信息',
      authorizations: '角色权限',
      operated_model_version_log_audits: '操作日志'
    },
    // 按钮
    btn: {
      edit_password: '修改密码',
      pwd_generation: '随机生成密码'
    },
    title: {
      change_password: '修改密码'
    },
    groups: {
      base_info: '基础信息',
      sign_in: '登录情况',
      login_info: '登录信息',
      auth_info: '权限信息',
      associated_admin: '关联管理员'
    },
    label: '管理员',
    admin_type: '身份类型',
    admin_types: {
      platform_admin: '平台管理员',
      station_admin: '站长',
      group_admin: '合作集团',
      shop_admin: '店员'
    },
    status: {
      enable_text: '接收中',
      disable_text: '暂停接收',
      enabled: '可用',
      disabled: '禁用'
    },
    placeholder: {
      search_keyword: '查找用户名/姓名/手机号/邮箱',
      input_username: '登录用户名。支持7~30位的字母、数字',
      input_email: '(不要填写虚构邮箱) 可用于登录、找回密码、收报警订阅信息',
      input_mobile: '手机号可用于运维端登录',
      input_password: '包含数字、字母与字符(!@#$)，长度不少于8位'
    },
    labels: {
      authorization: '权限',
      remember_pwd: '请记住密码'
    },
    tips: {
      platform_admin: '运营商管理员 - 可以访问平台所有允许的功能',
      station_admin: '站长 - 只能访问指定站、桩 和 部分相关信息',
      group_admin: '合作集团 - 只能访问指定的集团优惠信息',
      shop_admin: '店员 - 只能访问商品相关信息',
      login_association: '相同手机号下的管理员，登录后可切换至已关联的账号'
    },
    associated_admin: {
      create_associated_admin: '创建关联管理员成功',
      delete_associated_admin: '删除关联管理员成功'
    }
  }
}
